var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-layout",
            { staticClass: "card-bg-2", attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    md5: "",
                    "data-ui-component": "specimena-list",
                    CLASS: "divider-right",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline pb-2 specimen-info-card--title" },
                    [
                      _vm._v("\n          Plot Specimena\n          "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "rounded font-weight-regular",
                        attrs: {
                          label: "Search",
                          "prepend-inner-icon": "search",
                          "hide-details": "",
                          clearable: "",
                          solo: "",
                          placeholder: "Search specimen",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      items: _vm.plotDataSource.Specimena,
                      headers: _vm.specimenTableHeaders,
                      search: _vm.search,
                      "rows-per-page-items": _vm.specimenTableRowsPerPage,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c(
                              "tr",
                              {
                                staticClass: "clickable",
                                attrs: {
                                  active: _vm.isSelectedSpecimen(props.item),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleSpecimen(props.item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        attrs: {
                                          "hide-details": "",
                                          value: _vm.isSelectedSpecimen(
                                            props.item
                                          ),
                                        },
                                      },
                                      [
                                        _c("v-radio", {
                                          attrs: {
                                            color: "info",
                                            "hide-details": "",
                                            value: true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.ImportedSpeciesId)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.SpeciesCommonName)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(props.item.SpeciesFullLatinName)
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticClass: "divider-left",
                  attrs: {
                    xs12: "",
                    md7: "",
                    "data-ui-component": "specimena-metadata",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline pb-2 specimen-info-card--title" },
                    [_vm._v("Information")]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.informationTableHeaders,
                      items: _vm.specimenInformation,
                      "disable-initial-sort": "",
                      "hide-headers": "",
                      "hide-actions": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function ({ item, index }) {
                          return [
                            _c("tr", { class: { alternate: index % 2 == 0 } }, [
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "text-xs-left font-weight-medium",
                                },
                                [_vm._v(_vm._s(item.Field))]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-left" }, [
                                _vm._v(_vm._s(item.FieldValue)),
                              ]),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "no-data",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "pa-4 text-xs-center" },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { color: "warning", large: "" } },
                                  [_vm._v("filter_vintage")]
                                ),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n              Please select a specimen\n            "
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }